import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCalculateServiceInspectionMileageIntervalActionParams {
  form: UseFormReturn<BaseVehicle>;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next service inspection mileage.
 * Uses the last service inspection mileage and service inspection interval to calculate the next mileage.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance
 */
export const formCalculateServiceInspectionMileageIntervalAction = (
  _context: unknown,
  params: FormCalculateServiceInspectionMileageIntervalActionParams
): void => {
  const {form, value} = params;

  const lastServiceInspectionMileage = form.getValues(
    `serviceIntervals.serviceInspection.lastServiceInspectionMileage`
  );
  const serviceInspectionAfterMileage = value;

  if (!lastServiceInspectionMileage || !serviceInspectionAfterMileage) {
    return;
  }

  const nextMileage = lastServiceInspectionMileage + serviceInspectionAfterMileage;
  form.setValue(
    `serviceIntervals.serviceInspection.nextServiceInspectionMileage`,
    nextMileage,
    DEFAULT_OPTIONS
  );
};
